var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 12,
    fill: "#11161C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16 24.5523 15.5523 25 15 25C14.4477 25 14 24.5523 14 24C14 23.4477 14.4477 23 15 23C15.5523 23 16 23.4477 16 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 10.363 11.3111 9.0323 12.9405 9.00058C12.822 9.1332 12.75 9.30819 12.75 9.5C12.75 9.91421 13.0858 10.25 13.5 10.25H14.25V11.75H13.5C13.0858 11.75 12.75 12.0858 12.75 12.5C12.75 12.9142 13.0858 13.25 13.5 13.25H14.25V14.75H13.5C13.0858 14.75 12.75 15.0858 12.75 15.5C12.75 15.9142 13.0858 16.25 13.5 16.25H14.25V17.75H13.5C13.0858 17.75 12.75 18.0858 12.75 18.5C12.75 18.9142 13.0858 19.25 13.5 19.25H14.5C15.1904 19.25 15.75 18.6904 15.75 18V17.75H16.5C16.9142 17.75 17.25 17.4142 17.25 17C17.25 16.5858 16.9142 16.25 16.5 16.25H15.75V14.75H16.5C16.9142 14.75 17.25 14.4142 17.25 14C17.25 13.5858 16.9142 13.25 16.5 13.25H15.75V11.75H16.5C16.9142 11.75 17.25 11.4142 17.25 11C17.25 10.5858 16.9142 10.25 16.5 10.25H15.75V9H21.1716C21.702 9 22.2107 9.21071 22.5858 9.58579L27.4142 14.4142C27.7893 14.7893 28 15.298 28 15.8284V26C28 27.6569 26.6569 29 25 29H13C11.3431 29 10 27.6569 10 26V12ZM26 16L21 11V15C21 15.5523 21.4477 16 22 16H26ZM16 21C16 20.4477 15.5523 20 15 20C14.4477 20 14 20.4477 14 21V21.4381C14 21.9514 13.6907 22.4037 13.3869 22.8175C13.1437 23.1487 13 23.5576 13 24C13 25.1046 13.8954 26 15 26C16.1046 26 17 25.1046 17 24C17 23.5576 16.8563 23.1487 16.6131 22.8175C16.3093 22.4037 16 21.9514 16 21.4381V21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/icon_zip.234415a0099ca10f61ee852681fa0ad2.svg";
export { ForwardRef as ReactComponent };